import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class Story {
  constructor() {
    this.stories = document.querySelectorAll('.story');
    if (this.stories.length === 0) return;

    gsap.registerPlugin(ScrollTrigger);
    this.initStoryDivider();
  }

  initStoryDivider() {
    let storyDivider = document.querySelectorAll('.story__divider--top');

    storyDivider.forEach(item => {
      ScrollTrigger.create({
        trigger: item,
        start: 'top 75%',
        onEnter: () => {
          item.classList.add('animate')
        }
      });
    })
  }
}

